import { Button, CardData, InputText, Modal, Skeleton, Subtitulo, TextArea, TextLink } from 'app-principal-componentes-visuales';
import PageWrapper from '../../../components/PageWrapper/PageWrapper';
import React, { useContext, useEffect, useState } from 'react';
import { IonCol, IonRow } from '@ionic/react';
import Mapa from '../../../components/Map/Mapa';
import { FORMULARIO_DOMICILIO_YSOCIAL, GEOLOCALIZACION_PAGE_YSOCIAL } from '../../../utils/constants';
import { useHistory } from 'react-router';
import { capitalizeString, textIsValid } from '../../../utils/utils';
import Normalizacion from '../../../components/Modals/Normalizacion/Normalizacion';
import { YsocialContext } from '../../../contexts/YsocialContext';
import { Direccion } from '../../../interfaces/direccion.interface';
import { useDirecciones } from '../../../hooks/useDirecciones';
import { Coords, DireccionGeolocalizacion } from '../../../interfaces/geolocalizacion.interface';
import ObservacionesAdicionales from '../../../components/Modals/ObservacionesAdicionales/ObservacionesAdicionales';
import { validarProvincia } from '../../../helpers/geolocalizacion';
import { AsistenciaMedicaActionType } from '../../../interfaces/global-state/asistencia.medica.action.type.enum';
import './GeolocalizacionYsocial.scss';

const initialStateDireccion = { 
    barrio: '', calle: '', altura: '', piso: '', departamento: '', codigoPostal: '', 
    latitud: 0, longitud: 0, entreCalleUno: '', entreCalleDos: '', localidad: '', provincia: '', posicionExacta: false, observaciones: '', seleccionado: true
};

const initialStateCoords: Coords = {
    accuracy: 0,
    zoom: 18,
    latitude: 0,
    longitude: 0
}

const GeolocalizacionYsocial = () => {
    const history = useHistory();
    const { redirectTo } = (history.location.state as {redirectTo?: string}) || {};
    const { 
        ysocial, 
        storageManager, 
        dispatchYsocial, 
        useRequest, 
        isWeb 
    } = useContext(YsocialContext);
    const { apiRequest } = useRequest();
    const { usuario: socio, direccionSeleccionada, geolocalizacion } = ysocial;
    const direccionesSocio = socio?.direcciones;
    const [ selectedDirection, setSelectedDirection ] = useState<Direccion>(direccionSeleccionada); //TODO: Revisar direccionSeleccionada
    const [ loadingDireccion, setLoadingDireccion ] = useState<boolean>(true);
    const [ direccionGeo, setDireccionGeo ] = useState<DireccionGeolocalizacion>(null);
    const [ coords, setCoords ] = useState<Coords>(geolocalizacion?.coords || initialStateCoords);
    const [ showObservacionModal, setShowObservacionModal ] = useState(false);
    const [ showObservacionTextArea, setShowObservacionTextArea ] = useState(false);
    const direccionGeoInvalida = !direccionGeo?.calle || !direccionGeo?.altura || !direccionGeo?.localidad || !direccionGeo?.provincia;
    const { 
        addDirection,
        stateMerlin,
        edicionDireccion,
        handleNormalizacion,
        showNormalizacionModal,
        setShowNormalizacionModal,
        handleNormalizacionEditar,
        handleCloseModal,
        handleCloseModalEdit,
        merlinWaiting
    } = useDirecciones({
        socioPrincipal: socio, 
        apiRequest, 
        direccionesSocio, 
        isGeo: true, 
        isYsocial: true,
        redirectTo
    });

    useEffect(() => {
        if(direccionGeo) {
            let { barrio, calle, altura, localidad, provincia, latitud, longitud } = direccionGeo;
            const nuevaDireccion = { barrio, calle, altura, piso: '', departamento: '', codigoPostal: '', latitud, longitud, entreCalleUno: '', entreCalleDos: '', localidad, provincia, posicionExacta: false, observaciones: '', seleccionado: true };
            validarProvincia(apiRequest, storageManager, nuevaDireccion.provincia)
                .then(res => setSelectedDirection( res ? nuevaDireccion : initialStateDireccion))
                .catch(err => console.error(err))
        }
    }, [direccionGeo])

    const agregarUbicacion = () => {
        addDirection(selectedDirection)
    }

    const onHandleClickNormalizar = (data) => {
        if(edicionDireccion) {
            handleNormalizacionEditar(data)
        } else {
            handleNormalizacion(data)
        }
    }

    const onHandleCloseModal = () => {
        if(edicionDireccion) { 
            handleCloseModalEdit();
        } else { 
            handleCloseModal();
        }
    }

    const handleGoFormularioDireccion = () => {
        dispatchYsocial({
            type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
            geolocalizacion: {coords}
        });
        history.push(FORMULARIO_DOMICILIO_YSOCIAL, { selectedDirection, isGeo: true, redirectTo })
    }

    const handleAddDireccion = () => { 
        dispatchYsocial({
            type: AsistenciaMedicaActionType.actualizarGeolocalizacion,
            geolocalizacion: {coords}
        });
        history.push(FORMULARIO_DOMICILIO_YSOCIAL, {isGeo: true});
    }

    // /**
    //  * Se customiza handleBack para que no quede historial de rutas 
    //  * para cuando se avance a la pantalla de sintomas luego de agregar la direccion
    //  */
    // const handleBack = () => {
    //     history.replace(FORMULARIO_DOMICILIO_YSOCIAL, {redirectTo});
    // }

    /**
     * Metodo que setea en el state el input del piso al realizarse una modificacion
     */
    const handlePisoChange = (e) => {
        const noSpacesValue = e?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(e.target.value)
        if(isValid){
            setSelectedDirection(prevState => ({...prevState, piso: noSpacesValue}));
        } 
    }

    /**
     * Metodo que setea en el state el input del departamento al realizarse una modificacion
     */
    const handleDepartamentoChange = (e) => {
        const noSpacesValue = e?.target?.value?.replace(/^\s+/, '');
        const isValid = textIsValid(e.target.value)
        if(isValid){
            setSelectedDirection(prevState => ({...prevState, departamento: noSpacesValue}));
        } 
    }

    /**
     * Metodo que setea en el state el input de las observaciones al realizarse una modificacion
     */
    const handleObservacionesChange = (observaciones) => {
        setShowObservacionTextArea(true);
        const noSpacesValue = observaciones.replace(/^\s+/, '');
        const isValid = textIsValid(observaciones)
        if(isValid){
            setSelectedDirection(prevState => ({...prevState, observaciones: noSpacesValue}));
        } 
    }


    return (
        <>
            <PageWrapper 
                pageClassName='geolocalizacion-ysocial'
                path={GEOLOCALIZACION_PAGE_YSOCIAL}
                socio={socio}
                className='geolocalizacion-grid h-100 mb-40'
                // handlerHandleBack={handleBack}
            >
                <IonRow
                    className={isWeb && 'col--padding-top'}
                >  
                    <IonCol size='12'>
                        { geolocalizacion &&
                            <Mapa 
                                defaultCoords={geolocalizacion} 
                                setDireccionGeo={setDireccionGeo}
                                setLoadingDireccion={setLoadingDireccion}
                                setCoords={setCoords}
                                height={ 
                                    isWeb ?
                                        '80vh' :
                                        !(direccionGeo?.calle && direccionGeo?.altura && direccionGeo?.localidad) ?
                                            '70vh' : 
                                            showObservacionTextArea ? 
                                                '40vh' : 
                                                '50vh'
                                }
                            />
                        }
                    </IonCol>  
                </IonRow>
                <IonRow>  
                    <IonCol size='12' className='card-direccion-geo'>
                        {
                            merlinWaiting || loadingDireccion ? 
                                <Skeleton className="radio-item" height={100} />
                            :   
                                <>
                                    {!(direccionGeo?.calle && direccionGeo?.altura && direccionGeo?.localidad) ?
                                        <div className='direccion-no-encontrada-geo'>
                                            <Subtitulo
                                                titulo="No se encuentra la dirección, por favor agregala manualmente "
                                                className='geo-subtitulo'
                                            />
                                            <TextLink
                                                id=''
                                                className='geo-textlink'
                                                onClick={handleAddDireccion}
                                                texto='aquí.'
                                            />
                                        </div>
                                    :
                                        <>
                                            <CardData
                                                className='card-data-direccion-geo'
                                                asistencia
                                                direccion={
                                                    capitalizeString(`
                                                        ${direccionGeo?.calle} 
                                                        ${direccionGeo?.altura}
                                                        ${direccionGeo?.barrio ? ', ' + direccionGeo.barrio : ''}`) 
                                                }
                                                texto={capitalizeString(direccionGeo?.localidad)}
                                                linkEdit="Editar"
                                                onClick={handleGoFormularioDireccion}
                                            />
                                            <IonRow>
                                                <IonCol size='6' className='col--padding-right col--padding-top'>
                                                    <InputText
                                                        id='formulario-input-piso'
                                                        label='Piso'
                                                        normalLink
                                                        placeholder='Opcional'
                                                        type='text'
                                                        value={selectedDirection?.piso} 
                                                        onIonChange={handlePisoChange}
                                                    />
                                                </IonCol>
                                                <IonCol size='6' className='col--padding-left col--padding-top'>
                                                    <InputText
                                                        id='formulario-input-departamento'
                                                        label='Departamento'
                                                        normalLink
                                                        placeholder='Opcional'
                                                        type='text'
                                                        value={selectedDirection?.departamento}
                                                        onIonChange={handleDepartamentoChange}
                                                    />
                                                </IonCol>
                                            </IonRow>
                                            <IonRow className='col--padding-top col--padding-left col--padding-right'>
                                            {
                                                showObservacionTextArea ? 
                                                    <IonCol size='12'>
                                                        <TextArea
                                                            id="text-area-info-adicional"
                                                            label='Información adicional'
                                                            maxLength={100}
                                                            placeholder='Ingresá tu informacion adicional'
                                                            onIonChange={e => handleObservacionesChange(e.target.value)}
                                                            value={selectedDirection?.observaciones} 
                                                        />
                                                    </IonCol>
                                                :
                                                    <IonCol size="12">
                                                        <TextLink
                                                            id="verificar-datos-editar"
                                                            onClick={() => setShowObservacionModal(prevState => !prevState)}
                                                            right
                                                            texto="Agregar info adicional"
                                                        />
                                                    </IonCol>
                                            }
                                            </IonRow>
                                        </>
                                    }
                                </>
                        }
                    </IonCol>
                </IonRow>
                <IonRow className='sticky-button-container'>
                    <Button
                        className='btn-agregar-direccion'
                        disable={merlinWaiting || direccionGeoInvalida || loadingDireccion}
                        label="Agregar dirección"
                        primary
                        onClick={agregarUbicacion}
                    />
                </IonRow>
            </PageWrapper>
            
            {/* MODALES  */}

            <Modal
                className='modal_web'
                halfScreen={!isWeb}
                //@ts-ignore
                component={
                    <ObservacionesAdicionales 
                        setShowObservacionModal={setShowObservacionModal}
                        observacionText={selectedDirection?.observaciones}
                        setObservacionText={handleObservacionesChange}
                    />
                }
                setShowModal={setShowObservacionModal}
                showModal={showObservacionModal}
                id="modal-normalizacion"
            />            
            <Modal
                className='modal_web'
                screen60
                hideCloseBtn
                //@ts-ignore
                component={
                    <Normalizacion 
                        onClick={onHandleClickNormalizar} 
                        closeModal={onHandleCloseModal}
                        data={stateMerlin}
                        isWeb={isWeb}
                    />
                }
                setShowModal={setShowNormalizacionModal}
                showModal={showNormalizacionModal}
                id="modal-normalizacion"
            />
        </>
    )
}

export default GeolocalizacionYsocial;